import { Edge, Node } from 'reactflow';

import { BotMappieVersion } from '@/domain/bot-mappie';
import { addUnconnectedHandles } from 'utils/reactflow/add-unconnected-handles';
import { getHandlesFromEdges } from 'utils/reactflow/get-handles-from-edges';

/**
 * Sets up handles for custom internal modules by extracting them from edges
 * and adding any unconnected handles defined in the dialog
 *
 * @param nodes - The nodes from the bot version
 * @param edges - The edges from the bot version
 * @param botMappieVersion - The bot mappie version containing dialog information
 * @param getCustomModuleNodeHandles - Function to get current node handles
 * @param setCustomModuleNodeHandles - Function to set node handles
 */
export const setupCustomModuleHandles = (
    nodes: Node[],
    edges: Edge[],
    botMappieVersion: BotMappieVersion,
    getCustomModuleNodeHandles: (nodeId: string) => string[],
    setCustomModuleNodeHandles: (nodeId: string, handles: string[]) => void,
): void => {
    const allCustomModuleIds = nodes
        .map((node) => node.id)
        .filter((id) => id.startsWith('custom_internal_module'));

    if (allCustomModuleIds.length > 0) {
        allCustomModuleIds.forEach((id) =>
            setCustomModuleNodeHandles(id, getHandlesFromEdges(id, edges)),
        );

        addUnconnectedHandles(
            botMappieVersion.dialog,
            getCustomModuleNodeHandles,
            setCustomModuleNodeHandles,
        );
    }
};
